<template>
    <div>
        <template v-if="isLeaf(menuItem)&&menuItem.title&&menuItem.enable">
            <el-menu-item :index="menuItem.path" @click="handlerClickMenuItem(menuItem)">
                <i :class="menuItem.icon"></i>
                <span slot="title">{{menuItem.title}}</span>
            </el-menu-item>
        </template>

        <el-submenu v-else-if="menuItem.enable" :index="menuItem.path">
            <template slot="title" v-if="menuItem.title">
                <i :class="menuItem.icon"></i>
                <span slot="title">{{menuItem.title}}</span>
            </template>
            <sidebar-item v-for="child in menuItem.children"
                          :key="child.path"
                          :menuItem="child" />
        </el-submenu>
    </div>
</template>

<script>
    export default {
        name: 'SidebarItem',
        components: {
            
        },
        props: {
            menuItem: {// route object
                type: Object,
                required: true
            }
        },
        data() {
            return {
            }
        },
        methods: {
            isLeaf(obj) {
                if (!obj.children || obj.children.length==0)
                    return true;
                return false;
            },
            handlerClickMenuItem(menuItem) {
                this.$store.commit('app/ADD_TAB', menuItem);
            }
        }
    };
</script>

<style scoped>
</style>